module.exports = __webpack_public_path__ + "static/media/babyzeichensprache.4831cbc4.jpg";